import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ROLES } from '../../../users/users.roles';
import { PermissionService } from '../../../users/permission/permission.service';

const BANK_PRELOADING: { [key in ROLES]?: string } = {
  [ROLES.BCC_INDIVIDUAL_PERSON]: 'assets/bcc/base-preloader/base-preloader.gif',
  [ROLES.BCC_LEGAL_PERSON]: 'assets/bcc/base-preloader/base-preloader.gif',
  [ROLES.GEKKARD]: 'assets/gekkard/base-preloader/base-preloader.svg',
};

@Component({
  selector: 'app-is-loading',
  templateUrl: './is-loading.component.html',
  styleUrls: ['./is-loading.component.scss']
})
export class IsLoadingComponent implements OnInit {

  @Input() isLoading?: boolean;

  src: string;

  constructor(
   private permission: PermissionService
  ) { }

  ngOnInit() {
    this.permission.getActiveBankRole()
      .subscribe(res => this.src = BANK_PRELOADING[res]);
  }

}
